import { Request as request } from "@/utils/request";

let getEvent = (params) => {
  return request("https://api.vercel-apps.com/api/task-platform2/track-event", {
    method: "POST",
    params,
  });
};

export { getEvent };
